import React from 'react'
import PropTypes from "prop-types";
import Button from "components/CustomButtons/Button.jsx";

import './style.css'

class DetailsCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isDeleted: false,
            isAccepted: false,
            isDeclined: false,
        }
        this.deleteCard = this.deleteCard.bind(this);
        this.acceptCard = this.acceptCard.bind(this)
        this.declineCard = this.declineCard.bind(this);
    }

    deleteCard (event) {
        event.stopPropagation()
        this.setState({isDeleted: true})
    }

    acceptCard (event) {
        event.stopPropagation()
        this.setState({isAccepted: !this.state.isAccepted, isDeclined: false})
    }

    declineCard (event) {
        event.stopPropagation()
        this.setState({isDeclined: !this.state.isDeclined, isAccepted: false})
    }




    render() {
        return (
            <div className='code-card' style={{display: this.state.isDeleted ? 'none' : 'flex', color: this.state.isAccepted ? 'green' : this.state.isDeclined ? 'red' : "inherit"}} onClick={event => event.stopPropagation()}>
                <span>{this.props.field}</span>
                <div>{this.props.silent}</div>
                { this.props.isControlRequired ?
                    <div className={'buttons'}>
                        <Button 
                            size="sm" 
                            color="primary"
                            className={'button'} 
                            onClick={this.acceptCard}
                        >
                            Accept
                        </Button> 
                        <Button 
                            size="sm" 
                            color="primary"
                            className={'button'} 
                            onClick={this.declineCard}
                        >
                            Decline
                        </Button> 
                        <Button
                            size="sm" 
                            color="primary"
                            className={'button'} 
                            onClick={this.deleteCard}
                        >
                            Delete
                        </Button> 
                    </div> :
                    null
                }
            </div>
        )
    }
}

DetailsCard.propTypes = {
    isControlRequired: PropTypes.bool,
}

export default DetailsCard;


// WEBPACK FOOTER //
// ./src/components/DetailsCard/DetailsCard.jsx